import { z } from 'zod';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

/**
 * The firm's active users for a team picker (T-0227 / C2-10).
 *
 *   GET /api/v1/users/directory → [{ id, name, default_role }]
 *
 * Engagement leads assign colleagues to a client team but may not read
 * `GET /api/v1/users` (firm admins only: it carries emails, sign-in times
 * and overrides). The directory is the minimum a picker needs, for active
 * users only, since only active users can be assigned. Engagement leads
 * and up; the page asks for it only when the signed-in user may manage
 * the team.
 */

export const UserDirectoryItemSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  default_role: z.string(),
});
export type UserDirectoryItem = z.infer<typeof UserDirectoryItemSchema>;

export function listUserDirectory(): Promise<UserDirectoryItem[]> {
  return apiClient('/api/v1/users/directory', z.array(UserDirectoryItemSchema));
}

export function useUserDirectoryQuery(opts: { enabled: boolean }) {
  return useQuery({
    queryKey: ['users', 'directory'] as const,
    queryFn: listUserDirectory,
    enabled: opts.enabled,
    staleTime: 60_000,
  });
}
